import React, { useEffect, useState } from "react";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import Image from "react-bootstrap/Image";
import moment from "moment";
// import { PopupActionButton } from "../../buttonReusableComponent/ButtonReusableComponent";
import CallingButtonPopup from "../../allPopupReusable/CallingButtonPopup";
import SendSmsButton from "../../allPopupReusable/SendSmsButton";
import NotificationButton from "../../allPopupReusable/NotificationButton";
import ViewButtonPopup from "../../allPopupReusable/ViewButtonPopup";
import EditDiner from "../../../vendorDashboardComponents/seatingDashboard/EditDiner";
import { PopupIconButtonReusable } from "../../allPopupReusable/allPopupReusableIconButton/PopupIconButtonReusable";
import LocationReusable from "../../allPopupReusable/locationReusablePopup/LocationReusable";
import EditWaitTime from "../../allPopupReusable/tableNumberPopup/EditWaitTime";
import DeletePopup from "../../allPopupReusable/smallPopup/DeletePopup";
import { NewCountDown } from "../../allPopupReusable/tableNumberPopup/NewCountDown";
import {
  SwipeableList,
  SwipeableListItem,
} from "@sandstreamdev/react-swipeable-list";
import "@sandstreamdev/react-swipeable-list/dist/styles.css";

import ChatWindow from "../../../vendorDashboardComponents/seatingDashboard/seatingDashboard/ChatWindow";
import EnterTableNumber from "../../allPopupReusable/tableNumberPopup/EnterTableNumber";

export const SeatingDashboardMobile = ({
  indexKey,
  dinnerIdOriginal,
  dinnerId,
  dinnerOrderType,
  dinnerName,
  totalCount,
  totalAdult,
  totalKids,
  totalHighchair,
  totalHandicapped,
  displayLocation,
  date,
  time,
  displayButton,
  displayButtonTwo,
  seatingPreference,
  displayCall,
  displaySms,
  displayNotification,
  displayChat,
  displayViewDiner,
  displayEditDiner,
  tableNo,
  roomNo,
  specialOcassion,
  status,
  sendDataDinerProps,
  scanData,
  scanComplete,
  auth,
  ...props
}) => {
  const [openViewWhenScan, setopenViewWhenScan] = useState(false);
  useEffect(() => {
    if (scanData?.diner_id === dinnerIdOriginal) {
      setopenViewWhenScan(true);
    }
    // console.log(scanData?.diner_id, dinnerIdOriginal);
  }, [scanData, dinnerIdOriginal]);

  // var text = "blahalhahkanhklanlkanhlanlanhak";
  // var count = 15;
  // var result = text.slice(0, count) + (text.length > count ? "..." : "");
  const currentTime = new Date();
  var endTime = moment(currentTime).format("YYYY-MM-DDTHH:mm");
  const createdAt = new Date(sendDataDinerProps.createdAt);
  var startTime = moment(createdAt).format("YYYY-MM-DDTHH:mm");

  let dateOne = new Date(startTime);
  let dateTwo = new Date(endTime);

  let msDifference = dateTwo - dateOne;
  let minutes = Math.floor(msDifference / 1000 / 60);

  function time_convert(minutes) {
    var hours = Math.floor(minutes / 60);
    var nMinutes = minutes % 60;
    return hours + " HH : " + nMinutes + " min";
  }

  const updatedTime = new Date(
    sendDataDinerProps?.wait_time !== undefined
      ? sendDataDinerProps?.wait_time_date
      : sendDataDinerProps?.reservationTime
  );
  const currentTimeTwo = new Date().getTime();
  const updatedTimeNew = updatedTime.getTime();
  const waitTime =
    sendDataDinerProps?.wait_time !== undefined
      ? sendDataDinerProps?.wait_time * 60 * 1000
      : 0;
  let updateWaitTime = updatedTimeNew + waitTime;
  let diff = updateWaitTime - currentTimeTwo;

  // const updatedTime = new Date(
  //   sendDataDinerProps.wait_time_date || sendDataDinerProps.updatedAt
  // );
  // const currentTimeTwo = new Date().getTime();
  // const updatedTimeNew = updatedTime.getTime();
  // const waitTime = sendDataDinerProps.wait_time * 60 * 1000;
  // let updateWaitTime = updatedTimeNew + waitTime;
  // let diff = updateWaitTime - currentTimeTwo;

  const seatedTime = new Date(sendDataDinerProps.seatedTime);
  var endSeatedTime = moment(seatedTime).format("YYYY-MM-DDTHH:mm");
  var startTimeNew = moment(createdAt).format("YYYY-MM-DDTHH:mm");
  let dateOneSeated = new Date(startTimeNew);
  let dateTwoSeated = new Date(endSeatedTime);

  let msDifferenceSeated = dateTwoSeated - dateOneSeated;
  let minutesSeated = Math.floor(msDifferenceSeated / 1000 / 60);

  function seated_time_difference(minutesSeated) {
    var hours = Math.floor(minutesSeated / 60);
    var nMinutesSeated = minutesSeated % 60;
    return hours + " HH : " + nMinutesSeated + " min";
  }

  var date1 = new Date();
  var date2 = new Date(sendDataDinerProps.createdAt);

  var date3 = new Date(sendDataDinerProps.createdAt).getDate();
  var date4 = new Date(sendDataDinerProps.reservationTime).getTime();
  const [textShow, setTextShow] = useState(false);
  const textToggle = () => {
    setTextShow({
      textShow: !textShow.textShow,
    });
  };

  const [call, setCall] = useState(false);

  const [show, setShow] = useState(false);
  let vendorId = JSON.parse(localStorage.getItem("vendorId"));

  const [enterTableModal, setEnterTableModal] = useState(false);
  const setTablePopUp = (e) => {
    setEnterTableModal(true);
  };
  const setTablePopUpClose = (e) => {
    setEnterTableModal(false);
  };

  const [editWaitTimeModel, seteditWaitTimeModel] = useState(false);
  const changeEditWaitTimeModel = () => seteditWaitTimeModel(false);
  const openEditWaitTimeModel = () => seteditWaitTimeModel(true);

  return (
    <React.Fragment>
      <SwipeableList className={`swipe`}>
        {({ swipe, ...rest }) => (
          <div className={`${show ? "swipe" : ""}`}>
            <SwipeableListItem
              swipeLeft={{
                content: (
                  <div style={{ backgroundColor: "#f0f0f0" }}>
                    <div className="sectiontwo d-flex swipeOption">
                      <div className="p-1">
                        <Image
                          alt="wait"
                          title="wait"
                          width="10px"
                          height="13px"
                          src={require("../../../../assets/images/UserManagement/wait.svg")}
                        />
                        <div className="f9-400 opacity5">Total Wait time</div>
                        <div className="f10-500">
                          {sendDataDinerProps.diner_status === "NOTSEATED"
                            ? time_convert(minutes)
                            : seated_time_difference(minutesSeated) ||
                              sendDataDinerProps.diner_status === "PENDING"
                            ? time_convert(minutes)
                            : seated_time_difference(minutesSeated)}
                        </div>
                      </div>
                      <div className="sectiontwo-left">
                        {displayButton.diner_status === "NOTSEATED" ? (
                          <div>
                            <DeletePopup
                              buttonDisplay="smallCancelButton"
                              displayPopup="resonFforCancellation"
                              buttonText="Cancel"
                              bigText="Are you sure to Cancel ?"
                              dataSend={sendDataDinerProps._id}
                            />
                          </div>
                        ) : null || displayButton.diner_status === "SEATED" ? (
                          <div>
                            <DeletePopup
                              buttonDisplay="smallCancelButton"
                              displayPopup="seatingUnseated"
                              buttonText="Unseat"
                              bigText="Are you sure to Unseat ?"
                              dataSend={sendDataDinerProps}
                            />
                          </div>
                        ) : null || displayButton === "pendingReject" ? (
                          <div>
                            <DeletePopup
                              buttonDisplay="smallCancelButton"
                              displayPopup="resonFforCancellation"
                              buttonText="Reject"
                              bigText="Are you sure to Reject ?"
                              dataSend={sendDataDinerProps._id}
                            />
                          </div>
                        ) : null ||
                          displayButton.diner_status === "COMPLETED" ||
                          displayButton.diner_status === "REJECTED" ? (
                          <div>
                            <DeletePopup
                              buttonDisplay="smallCancelButton"
                              displayPopup="historyReset"
                              buttonText="Reset"
                              bigText="Are you sure to Reset ?"
                              dataSend={sendDataDinerProps}
                              buttonClass="yesButton"
                            />
                          </div>
                        ) : null}
                      </div>

                      <div className="sectionthree-right">
                        {displayButton.diner_status === "NOTSEATED" ? (
                          <div>
                            {/* <DeletePopup
                              buttonDisplay="smallSaveButton"
                              displayPopup="SeatedButton"
                              buttonText="Seat"
                              bigText="Are you sure to Seated ?"
                              mobile={true}
                              dataSend={sendDataDinerProps._id}
                            /> */}
                            <button
                              class="n_button_d_status font_18_m popup-save-button"
                              type="button"
                              onClick={() => setTablePopUp()}
                            >
                              Seat
                            </button>
                          </div>
                        ) : null || displayButton.diner_status === "SEATED" ? (
                          <div>
                            <DeletePopup
                              buttonDisplay="smallSaveButton"
                              displayPopup="seatingCompleted"
                              buttonText="Complete"
                              bigText="Are you sure to Completed ?"
                              dataSend={sendDataDinerProps}
                            />
                          </div>
                        ) : null || displayButtonTwo === "pendingAccept" ? (
                          sendDataDinerProps.service_type === "RESERVATION" ? (
                            sendDataDinerProps.service_type === "RESERVATION" &&
                            date4 < date1.getTime() ? (
                              ""
                            ) : (
                              // <DeletePopup
                              //   buttonDisplay="smallSaveButton"
                              //   displayPopup="acceptButtonReservation"
                              //   buttonText="Accept"
                              //   bigText="Are you sure you want to accept ?"
                              //   dataSend={sendDataDinerProps}
                              // />
                              <DeletePopup
                                buttonDisplay="acceptButtonReservation"
                                // displayPopup="acceptButtonReservation"
                                buttonText="Accept"
                                bigText="Request Accept"
                                reasonText="Are you sure you want to accept ?"
                                dataSend={props.dinerInfo}
                                actionBy={props.actionPerformBy}
                                pathAction="HISTORY"
                                mobile
                                adminSendVendorId={vendorId}
                              />
                            )
                          ) : sendDataDinerProps.service_type === "SEATING" &&
                            date3 < date1.getDate() ? (
                            ""
                          ) : (
                            <DeletePopup
                              buttonDisplay="smallSaveButton"
                              displayPopup="acceptButton"
                              buttonText="Accept"
                              bigText="Are you sure you want to accept ?"
                              dataSend={sendDataDinerProps._id}
                              mobile
                            />
                          )
                        ) : // (
                        //   <DeletePopup
                        //     buttonDisplay="smallSaveButton"
                        //     displayPopup="acceptButton"
                        //     buttonText="Accept"
                        //     bigText="Are you sure you want to accept ?"
                        //     dataSend={sendDataDinerProps._id}
                        //   />
                        // )
                        null}
                      </div>
                    </div>
                  </div>
                ),
                action: () => setShow(true),
              }}
              swipeRight={{
                // content: <div>Revealed content during swipe</div>,
                action: () => setShow(false),
              }}
              {...rest}
            >
              <Card className="main-reusable-accordion">
                <Accordion.Toggle
                  as={Card.Header}
                  eventKey={indexKey + 1}
                  className={`${
                    // sendDataDinerProps?.service_type === "RESERVATION"
                    //   ? "enLeftYellowLine"
                    // :
                    props?.dinerInfo?.userConfirmed === true
                      ? "enLeftGReenLine"
                      : "enLeftYellowLine"
                  } `}
                >
                  <div
                    className="d-flex align-items-center"
                    style={{ borderRadius: "20px" }}
                  >
                    <div className="card-header-left">
                      <div className="d-flex align-items-start">
                        {sendDataDinerProps.isWalkIn === true &&
                        sendDataDinerProps.service_type === "SEATING" ? (
                          <Image
                            src={require("../../../../assets/images/ActionImages/image/walkin.svg")}
                            alt="Order Type"
                            title="Order Type"
                            className="order-type-Image"
                          />
                        ) : null ||
                          (sendDataDinerProps.isWalkIn === false &&
                            sendDataDinerProps.service_type === "SEATING") ? (
                          <Image
                            src={require("../../../../assets/images/ActionImages/image/waitlist.svg")}
                            alt="Order Type"
                            title="Order Type"
                            className="order-type-Image"
                          />
                        ) : null ||
                          sendDataDinerProps.service_type === "RESERVATION" ? (
                          <Image
                            src={require("../../../../assets/images/ActionImages/image/reservation.svg")}
                            alt="Order Type"
                            title="Order Type"
                            className="order-type-Image"
                          />
                        ) : null}
                        <div>
                          <p
                            // className={
                            //   sendDataDinerProps.service_type === "SEATING"
                            //     ? "order-diner-name-green"
                            //     : null ||
                            //       sendDataDinerProps.service_type === "RESERVATION"
                            //     ? "order-diner-name-yellow"
                            //     : null
                            // }
                            className="f10-500"
                          >
                            {dinnerName}
                          </p>
                          <p className="f9-400">{dinnerId}</p>
                        </div>
                      </div>
                    </div>
                    <div
                      className={
                        //dinnerOrderType === "waitlist" ||
                        dinnerOrderType === "reservation" ||
                        status === "seated" ||
                        status === "pending"
                          ? "card-header-middle"
                          : "card-header-middle"
                      }
                    >
                      <div className="d-flex align-items-center">
                        <div className="total-pax">
                          <p className="f14-700 text-right">{totalCount}</p>
                          <p className="f10-700">PAX</p>
                        </div>
                        <div className="total-adult-kids">
                          <div className="display-align">
                            <Image
                              src={require("../../../../assets/images/ActionImages/employees.png")}
                              alt="Adult"
                              title="Adult"
                              className="pax-type-Image"
                            />
                            <p className="total-count">{totalAdult}</p>
                          </div>
                          <div className="display-align  mb-0">
                            <Image
                              src={require("../../../../assets/images/ActionImages/children.png")}
                              alt="Kids"
                              title="Kids"
                              className="pax-type-Image"
                            />
                            <p className="total-count">{totalKids}</p>
                          </div>
                        </div>
                        <div className="total-highchair-handicapp">
                          <div className="display-align">
                            <Image
                              src={require("../../../../assets/images/ActionImages/highchair.png")}
                              alt="Highchair"
                              title="Highchair"
                              className="pax-type-Image-highchair"
                            />
                            <p className="total-count">{totalHighchair}</p>
                          </div>
                          <div className="display-align mb-0">
                            <Image
                              src={require("../../../../assets/images/ActionImages/wheelchair.png")}
                              alt="Handicapped"
                              title="Handicapped"
                              className="pax-type-Image-handicapped"
                            />
                            <p className="total-count">{totalHandicapped}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className={` mr-2 ${
                        // dinnerOrderType === "waitlist" ||
                        sendDataDinerProps?.service_type === "RESERVATION"
                          ? "card-header-right text-left"
                          : dinnerOrderType === "reservation" ||
                            status === "SEATED" ||
                            status === "NOTSEATED" ||
                            status === "PENDING" ||
                            status === "REJECTED" ||
                            status === "COMPLETED"
                          ? "card-header-right justify-content-center"
                          : "card-header-right"
                      }`}
                    >
                      {sendDataDinerProps?.service_type === "RESERVATION" ||
                      status === "PENDING" ? (
                        <div>
                          <div className="d-flex align-items-center justify-content-between">
                            <div>
                              {/* <p className="wait-time-headtext">Wait Time</p> */}
                              <div>
                                <p className="f14-700 text-red mobile-f10-700">
                                  {/* {sendDataDinerProps.service_type === "RESERVATION" ? (
                          "0:0:0"
                        ) : ( */}
                                  <NewCountDown waitNew={diff} />
                                  {/* )} */}
                                </p>
                                {/* <p className="wait-time-boldtwo">HH:MM:SS</p> */}
                              </div>
                            </div>
                            <div className="popup-image">
                              {/* {sendDataDinerProps.isWalkIn === true ||
                    sendDataDinerProps.service_type === "RESERVATION" ? (
                      ""
                    ) : ( */}
                              <EditWaitTime
                                allDataProps={sendDataDinerProps._id}
                              />
                              {/* )} */}
                            </div>
                          </div>
                          <p className="f10-700">
                            {moment(props.reservationTime).format(
                              "Do MMM YYYY"
                            )}
                          </p>
                          <div>
                            <p className="f10-700">
                              {moment(props.reservationTime).format("hh:mm A")}
                            </p>
                          </div>
                        </div>
                      ) : null || status === "SEATED" ? (
                        <div>
                          {/* <p className="wait-time-headtext">Wait Time</p> */}
                          <div>
                            <p className="f14-700 text-red">00:00</p>
                          </div>
                        </div>
                      ) : null || status === "NOTSEATED" ? (
                        <div className="d-flex align-items-center justify-content-between">
                          <div>
                            {/* <p className="wait-time-headtext">Wait Time</p> */}
                            <div>
                              <p className="f14-700 text-red">
                                {/* {sendDataDinerProps.service_type === "RESERVATION" ? (
                          "0:0:0"
                        ) : ( */}
                                <NewCountDown waitNew={diff} />
                                {/* )} */}
                              </p>
                              {/* <p className="wait-time-boldtwo">HH:MM:SS</p> */}
                            </div>
                          </div>
                          <div className="popup-image">
                            {/* {sendDataDinerProps.isWalkIn === true ||
                    sendDataDinerProps.service_type === "RESERVATION" ? (
                      ""
                    ) : ( */}
                            <EditWaitTime
                              allDataProps={sendDataDinerProps._id}
                            />
                            {/* )} */}
                          </div>
                        </div>
                      ) : null || status === "REJECTED" ? (
                        <div>
                          <p className="f14-700 text-red">Rejected</p>
                        </div>
                      ) : null || status === "COMPLETED" ? (
                        <div>
                          <p className="f14-700 text-red">Completed</p>
                        </div>
                      ) : null || status === "CANCELLED" ? (
                        <div className="w-100">
                          <p className="f14-700 text-red">Cancelled</p>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </Accordion.Toggle>
                <Accordion.Collapse
                  eventKey={indexKey + 1}
                  className={`${openViewWhenScan ? `show` : ""}`}
                >
                  <Card.Body>
                    {/******* Section One *********/}
                    <hr className="mt-0" />
                    <div className="row">
                      <div className="col-3 sectionone-left">
                        <p className="f10-700 pb-2 opacity5">
                          Seating Preferences
                        </p>
                        <p className="f10-700">{seatingPreference}</p>
                      </div>
                      <div className="col-5 sectionone-middle border-right border-left">
                        <p className="f10-700 pb-2 opacity5">
                          Date & Time
                          <br />
                          &nbsp;&nbsp;
                        </p>

                        <div className="f10-700">
                           {time} {date}
                        </div>
                      </div>
                      <div className="col-4 sectionone-right">
                        {/* {console.log("auth", auth)} */}
                        {/* {auth.user?.VendorUser?.role !== "vendor" ? (
                          <></>
                        ) : (
                          <> */}
                        <p className="f10-500 pb-2 text-blue">
                          Track User <br />
                          &nbsp;&nbsp;
                        </p>
                        <div className="box-border flex-start">
                          {displayLocation === true ? (
                            <LocationReusable dataSend={sendDataDinerProps} />
                          ) : (
                            <LocationReusable dataSend={sendDataDinerProps} />
                          )}
                        </div>
                        {/* </>
                        )} */}
                      </div>
                    </div>
                    {/******* Section Two *********/}
                    <hr />
                    <div
                      className={
                        "action-section-body d-flex align-items-center"
                      }
                      style={{ justifyContent: "space-evenly" }}
                    >
                      {displayButton.diner_status === "NOTSEATED" ? (
                        <div className="mr-2">
                          <DeletePopup
                            buttonDisplay="smallCancelButton"
                            displayPopup="resonFforCancellation"
                            buttonText="Cancel"
                            bigText="Are you sure to Cancel ?"
                            dataSend={sendDataDinerProps._id}
                          />
                        </div>
                      ) : null || displayButton.diner_status === "SEATED" ? (
                        <div className="mr-2">
                          <DeletePopup
                            buttonDisplay="smallCancelButton"
                            displayPopup="seatingUnseated"
                            buttonText="Unseat"
                            bigText="Are you sure to Unseat ?"
                            dataSend={sendDataDinerProps}
                          />
                        </div>
                      ) : null || displayButton === "pendingReject" ? (
                        <div className="mr-2">
                          <DeletePopup
                            buttonDisplay="smallCancelButton"
                            displayPopup="resonFforCancellation"
                            buttonText="Reject"
                            bigText="Are you sure to Reject ?"
                            dataSend={sendDataDinerProps._id}
                          />
                        </div>
                      ) : null ||
                        displayButton.diner_status === "COMPLETED" ||
                        displayButton.diner_status === "REJECTED" ? (
                        <div className="mr-2">
                          <DeletePopup
                            buttonDisplay="smallCancelButton"
                            displayPopup="historyReset"
                            buttonText="Reset"
                            bigText="Are you sure to Reset ?"
                            dataSend={sendDataDinerProps}
                          />
                        </div>
                      ) : null}
                      <div className="middle-timer">
                        <p className="f9-400 text-center">Total Wait time</p>
                        <div className="enTimesLbl d-flex justify-content-center align-items-center">
                          <Image
                            alt="wait"
                            title="wait"
                            width="10px"
                            height="13px"
                            src={require("../../../../assets/images/UserManagement/wait.svg")}
                          />
                          <p className="f10-500 pl-1">
                            {sendDataDinerProps.diner_status === "NOTSEATED"
                              ? time_convert(minutes)
                              : seated_time_difference(minutesSeated)}
                          </p>
                        </div>
                        <p className="f10-500 text-center">
                          Status:&nbsp;
                          <span className="f10-700">
                            {sendDataDinerProps.diner_status === "NOTSEATED"
                              ? "NOT SEATED"
                              : "SEATED"}
                          </span>
                        </p>
                      </div>
                      {displayButton.diner_status === "NOTSEATED" ? (
                        <div className="ml-2">
                          {/* <DeletePopup
                            buttonDisplay="smallSaveButton"
                            displayPopup="SeatedButton"
                            buttonText="Seat"
                            bigText="Are you sure to Seated ?"
                            dataSend={sendDataDinerProps._id}
                          /> */}

                          <EnterTableNumber
                            buttonText="Seat"
                            setTablePopUpClose={setTablePopUpClose}
                            setTablePopUp={setTablePopUp}
                            enterTableModal={enterTableModal}
                            // closedMainModal={onCloseModal}
                            allDataProps={sendDataDinerProps._id}
                            // disabled={true}
                          />
                        </div>
                      ) : null || displayButton.diner_status === "SEATED" ? (
                        <div className="ml-2">
                          <DeletePopup
                            buttonDisplay="smallSaveButton"
                            displayPopup="seatingCompleted"
                            buttonText="Complete"
                            bigText="Are you sure to Completed ?"
                            dataSend={sendDataDinerProps}
                          />
                        </div>
                      ) : null || displayButtonTwo === "pendingAccept" ? (
                        sendDataDinerProps.service_type === "RESERVATION" ? (
                          sendDataDinerProps.service_type === "RESERVATION" &&
                          date4 < date1.getTime() ? (
                            ""
                          ) : (
                            // <DeletePopup
                            //   buttonDisplay="smallSaveButton"
                            //   displayPopup="acceptButtonReservation"
                            //   buttonText="Accept"
                            //   bigText="Are you sure you want to accept ?"
                            //   dataSend={sendDataDinerProps}
                            // />
                            <DeletePopup
                              buttonDisplay="acceptButtonReservation"
                              // displayPopup="acceptButtonReservation"
                              buttonText="Accept"
                              bigText="Request Accept"
                              reasonText="Are you sure you want to accept ?"
                              dataSend={props.dinerInfo}
                              actionBy={props.actionPerformBy}
                              pathAction="HISTORY"
                              mobile
                              adminSendVendorId={vendorId}
                            />
                          )
                        ) : sendDataDinerProps.service_type === "SEATING" &&
                          date3 < date1.getDate() ? (
                          ""
                        ) : (
                          <DeletePopup
                            buttonDisplay="smallSaveButton"
                            displayPopup="acceptButton"
                            buttonText="Accept"
                            bigText="Are you sure you want to accept ?"
                            mobile
                            dataSend={sendDataDinerProps._id}
                          />
                        )
                      ) : null}
                    </div>
                    {/******* Section Three *********/}
                    <hr />
                    <div className="col-12 sectionthree">
                      <div className="d-flex align-items-center justify-content-center">
                        {displayCall === true ? (
                          <CallingButtonPopup
                            buttonClass="smallButton"
                            sendData={props.dinerInfo}
                            defaultOpen={call}
                            setClose={(e) => setCall(false)}
                          />
                        ) : null}
                        {displaySms === true ? (
                          <SendSmsButton
                            buttonClass="smallButton"
                            dataSend={props.dinerInfo}
                          />
                        ) : null}
                        {displayNotification === true ? (
                          <NotificationButton
                            buttonClass="smallButton"
                            dataSend={props.dinerInfo}
                          />
                        ) : null}
                        {displayChat === true ? (
                          <ChatWindow
                            data={props.dinerInfo}
                            text={props.actionBy}
                          />
                        ) : null}
                        {displayViewDiner === true ? (
                          <div className="btnMobile">
                            <ViewButtonPopup
                              seatingViewPopUp={true}
                              actionByData={props.actionBy}
                              setCall={(e) => setCall(true)}
                              buttonClass="smallButton"
                              dataSend={sendDataDinerProps}
                              defaultOpen={openViewWhenScan}
                              viewRequest
                              setOpenFalse={() => setopenViewWhenScan(false)}
                              diff={diff}
                              changeEditWaitTimeModel={changeEditWaitTimeModel}
                            />
                          </div>
                        ) : null}
                        {displayEditDiner === true &&
                        date2.getDate() < date1.getDate() ? (
                          ""
                        ) : (
                          <div className="btnMobile">
                            <EditDiner
                              buttonClass="smallButton"
                              bigText="Edit Diner"
                              origin="mobile"
                              dataSend={sendDataDinerProps}
                              actionByData={props.actionBy}
                              // socket={props.socket}
                              diff={diff}
                              changeEditWaitTimeModel={changeEditWaitTimeModel}
                            />
                          </div>
                        )}
                      </div>
                    </div>

                    {/******* Section Four *********/}
                    <hr />
                    <div className="col-12 sectionfour">
                      <div className="sectionfour-left">
                        <p className="f10-700 pb-2 opacity5">
                          Table No. - / Room No.-
                        </p>
                        <p className="f10-400"> {roomNo}</p>
                        <p className="f10-400"> {tableNo}</p>
                      </div>
                      <div className="sectionfour-middle border-right border-left">
                        <p className="f10-700 pb-2 opacity5">
                          Special Occasion
                        </p>
                        <p
                          className={`f10-400 ${
                            !textShow.textShow ? "enEllips3" : null
                          }`}
                        >
                          {specialOcassion}
                        </p>
                        <span
                          className="f10-400 cursor text-red"
                          onClick={textToggle}
                        >
                          See More
                        </span>
                      </div>
                      <div className="sectionfour-right pl-1">
                        <p className="f10-700 pb-2 opacity5">Status</p>
                        <p className="f10-700">
                          {status === "NOTSEATED" ? (
                            <div className="d-flex align-items-center">
                              <span className="mr-2 enYellowDot"></span>
                              <span>{status}</span>
                            </div>
                          ) : (
                            status
                          )}
                        </p>
                      </div>
                    </div>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
            </SwipeableListItem>
          </div>
        )}
      </SwipeableList>
    </React.Fragment>
  );
};
